import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useMemo } from "react";

const CustomPagination = ({ totalItems, pageSize = 10, currentPage = 1, setCurrentPage }) => {
        const totalPages = Math.ceil(totalItems / pageSize);

        const handlePrevious = () => {
                if (currentPage > 1) setCurrentPage(currentPage - 1);
        };

        const handleNext = () => {
                if (currentPage < totalPages) setCurrentPage(currentPage + 1);
        };

        const pages = useMemo(() => {
                if (totalPages <= 5) {
                        return Array.from({ length: totalPages }, (_, i) => i + 1);
                }

                const pages = [1]; // Always include the first page

                if (currentPage > 3) {
                        pages.push('...');
                }

                let startPage = Math.max(2, currentPage - 1);
                let endPage = Math.min(totalPages - 1, currentPage + 1);

                for (let i = startPage; i <= endPage; i++) {
                        pages.push(i);
                }

                if (currentPage < totalPages - 2) {
                        pages.push('...');
                }

                pages.push(totalPages); // Always include the last page

                return pages;
        }, [totalPages, currentPage]);

        return (
                <div className="flex justify-between items-center my-4">
                        {totalItems < pageSize * currentPage ? (
                                <p className="text-[#6D6D6D] font-inter">
                                        Showing {totalItems} of {totalItems} Results
                                </p>
                        ) : (
                                <p className="text-[#6D6D6D] font-inter">
                                        Showing {pageSize * currentPage} of {totalItems} Results
                                </p>
                        )}

                        <div className="bg-[#F6F6F6] border border-[#D1D1D1] rounded-lg shadow-md flex gap-1">
                                {/* Previous Button */}
                                <button
                                        onClick={handlePrevious}
                                        disabled={currentPage === 1}
                                        className="p-3"
                                        aria-label="Previous page"
                                >
                                        <LeftOutlined className="text-sm" />
                                </button>

                                {/* Page Numbers */}
                                {pages.map((page, index) =>
                                        page === '...' ? (
                                                <span
                                                        key={`key-${index}-page-${page}`}
                                                        className="p-3 border-r"
                                                >
                                                        ...
                                                </span>
                                        ) : (
                                                <button
                                                        key={`key-${index}-page-${page}`}
                                                        onClick={() => setCurrentPage(page)}
                                                        className={`p-3 border-r ${
                                                                currentPage === page
                                                                        ? 'bg-[#F7FBEA] text-black'
                                                                        : ''
                                                        }`}
                                                >
                                                        {page}
                                                </button>
                                        ),
                                )}

                                {/* Next Button */}
                                <button
                                        onClick={handleNext}
                                        disabled={currentPage === totalPages}
                                        className="p-3"
                                        aria-label="Next page"
                                >
                                        <RightOutlined className="text-sm" />
                                </button>
                        </div>
                </div>
        );
};

export default CustomPagination;
